import { convertObjToQueryString } from "../../utils/helpers";

export const getBulkUsersForTrainer = (queryObj: { [key: string]: any }) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/v1/trainer/users/bulk-get-active-subscriptions${query}`,
  };
};

export const getAllTrainersList = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/trainers`,
  };
};

export const getTrainerData = (
  queryObj: { [key: string]: any },
  userId: string | undefined
) => {
  const query = convertObjToQueryString(queryObj);

  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/trainer${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getUserNotes = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/notes/v1/list-notes`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const addUserNotes = (
  data: { [key: string]: any },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_TRAINER_URL}/notes/v1/add-note`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getTrainerPermissionList = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/permission/v1/list-permissions`,
  };
};

export const getTrainerPermissionDetail = (
  permissionId: string | undefined
) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/permission/v1/permission-detail/${permissionId}`,
  };
};

export const updateTrainerPermission = (
  data: { [key: string]: any },
  permissionId: string | undefined
) => {
  return {
    method: "PUT",
    url: `${process.env.REACT_APP_TRAINER_URL}/permission/v1/update-permission/${permissionId}`,
    data,
  };
};

export const addTrainerPermissions = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_TRAINER_URL}/permission/v1/create-permission`,
    data,
  };
};

export const getUserPrescriptionList = (userId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/medical-prescriptions/v1/prescriptions-list`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getUserPrescriptionDetails = (
  userId: string | undefined,
  queryObj: { [key: string]: any }
) => {
  const query = convertObjToQueryString(queryObj);
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/medical-prescriptions/v1/get-prescription-by-id${query}`,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const createUserPrescription = (
  data: { [key: string]: any },
  userId: string | undefined
) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_TRAINER_URL}/prescription/v1/generate-prescription`,
    data,
    headers: {
      "x-user-id": userId,
    },
  };
};

export const getTrainerRoleList = () => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/role/v1/list-roles`,
  };
};

export const createTrainerRole = (data: { [key: string]: any }) => {
  return {
    method: "POST",
    url: `${process.env.REACT_APP_TRAINER_URL}/role/v1/create-role`,
    data,
  };
};

export const getTrainerRoleDetails = (roleId: string | undefined) => {
  return {
    method: "GET",
    url: `${process.env.REACT_APP_TRAINER_URL}/role/v1/role-detail/${roleId}`,
  };
};

export const updateTrainerRole = (
  data: { [key: string]: any },
  roleId: string | undefined
) => {
  return {
    method: "PUT",
    url: `${process.env.REACT_APP_TRAINER_URL}/role/v1/update-role/${roleId}`,
    data,
  };
};
